import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button, Modal } from '@salesforce/design-system-react';

import ErrorList from './ErrorList';

import './ErrorModal.scss';

class ErrorModal extends Component {
  close() {
    this.props.actions.closeModal(this.props.modalName);
  }

  isOpen() {
    return !!(
      this.props.modals[this.props.modalName] &&
      this.props.modals[this.props.modalName].isOpen
    );
  }

  errors() {
    return (
      (this.props.modals[this.props.modalName] &&
        this.props.modals[this.props.modalName].data) ||
      []
    );
  }

  footer() {
    const { formatMessage } = this.props.intl;
    return [
      <Button
        key="done-button"
        label={formatMessage({ id: 'common.actions.done' })}
        variant="brand"
        onClick={this.close.bind(this)}
      />
    ];
  }

  render() {
    const { formatMessage } = this.props.intl;
    const title = formatMessage({
      id: this.props.title || 'components.ecs.error.defaultTitle'
    });
    return (
      <Modal
        heading={title}
        onRequestClose={this.close.bind(this)}
        isOpen={this.isOpen()}
        size="medium"
        footer={this.footer()}
      >
        <div className="error-list-container">
          <ErrorList errors={this.errors()} />
        </div>
      </Modal>
    );
  }
}

ErrorModal.propTypes = {
  actions: PropTypes.object,
  modals: PropTypes.object,
  modalName: PropTypes.string.isRequired,
  title: PropTypes.string,
  location: PropTypes.object
};

export default injectIntl(ErrorModal);
